// extracted by mini-css-extract-plugin
export default {"icon":"Job_icon__+hYvD"};